import { ref, readonly } from 'vue';
import zhHant from './zh-Hant.json';
import zhHans from './zh-Hans.json';
import en from './en.json';
export const LOCALES = ['zh-Hant', 'zh-Hans', 'en'];
export const STORAGE_KEY = 'pcd.locale.v1';
export const messages = { 'zh-Hant': zhHant, 'zh-Hans': zhHans, en };
export function detectLocale(languages = []) {
  for (const language of languages) {
    const tag = String(language).toLowerCase();
    if (/^zh(?:-|$)/.test(tag)) {
      if (/hant/.test(tag)) return 'zh-Hant';
      if (/hans/.test(tag)) return 'zh-Hans';
      return /tw|hk|mo/.test(tag) ? 'zh-Hant' : 'zh-Hans';
    }
    if (/^en(?:-|$)/.test(tag)) return 'en';
  }
  return 'zh-Hant';
}
function initialLocale() {
  try { const saved = localStorage.getItem(STORAGE_KEY); if (LOCALES.includes(saved)) return saved; } catch { /* Storage can be unavailable in a wallet WebView. */ }
  return detectLocale(typeof navigator === 'undefined' ? [] : navigator.languages?.length ? navigator.languages : [navigator.language]);
}
const current = ref(initialLocale());
export const locale = readonly(current);
function documentLanguage() { if (typeof document !== 'undefined') document.documentElement.lang = current.value; }
export function setLocale(value) {
  if (!LOCALES.includes(value)) return;
  current.value = value;
  documentLanguage();
  try { localStorage.setItem(STORAGE_KEY, value); } catch { /* Keep the current in-memory selection usable. */ }
}
const escape = value => [...value].map(char => '.*+?^$()[]{}|'.includes(char) || char.charCodeAt(0) === 92 ? String.fromCharCode(92) + char : char).join('');
// Match only catalogued app-authored messages; never rewrite DOM or business state.
const patterns = Object.keys(zhHant).filter(key => /[{][0-9]+[}]/.test(key)).map(key => {
  const captures = [];
  const source = key.split(/([{][0-9]+[}])/).map(part => {
    if (/^[{][0-9]+[}]$/.test(part)) { captures.push(part); return '(.*?)'; }
    return escape(part);
  }).join('');
  return { key, captures, regex: new RegExp('^' + source + '$', 's'), weight: key.replace(/[{][0-9]+[}]/g, '').length };
}).sort((a, b) => b.weight - a.weight);
export function translate(value, language, depth = 0) {
  if (typeof value !== 'string' || !value || language === 'zh-Hant') return value;
  const catalog = messages[language] || zhHant;
  if (Object.prototype.hasOwnProperty.call(catalog, value)) return catalog[value];
  const list = value.split('、');
  if (list.length > 1 && list.every(item => Object.prototype.hasOwnProperty.call(zhHant, item)))
    return list.map(item => translate(item, language, depth + 1)).join(language === 'en' ? ', ' : '、');
  if (depth < 4) for (const entry of patterns) {
    const match = value.match(entry.regex);
    if (match) return (catalog[entry.key] || entry.key).replace(/[{][0-9]+[}]/g, token => {
      const index = entry.captures.indexOf(token);
      return index < 0 ? token : translate(match[index + 1], language, depth + 1);
    });
  }
  return value;
}
export function t(value) { return translate(value, current.value); }
documentLanguage();
